VegasShop.Filters = {
	form: '#shop-filter-form',
	filters: '.vg-shop-filters',
	filter: '.vg-shop-filters__item',
	search_min_item: 15,
	inputs: {},
	init: function () {
		VegasShop.Filters.getInputs();
		VegasShop.Filters.setInputs();
		VegasShop.Filters.selectedSet();
	},
	toggle: function ($filter, $self, set) {
		let $toggle_param = $filter.find('[data-toggle=param]'),
			inputs = VegasShop.Filters.getInputs(),
			type = $filter.data('type'),
			param = $filter.find('[data-param]').data('param');

		if (set === 'radio-checker') {
			$toggle_param.on('click', function () {
				if (Object.keys([set]).length) {
					inputs.sort = $(this).data('value');
				} else {
					inputs = {
						sort: $(this).data('value')
					}
				}

				VegasShop.Filters.inputs = inputs;
				VegasShop.Filters.setInputs();
				return VegasShop.Filters.submit();
			});
		}

		if (set === 'single') {
			let value;

			if (!$self.hasClass('selected')) {
				$self.addClass('selected');
				value = 1;

				if (value > 0) {
					inputs[param] = value;
				} else {
					delete inputs[param];
				}

				VegasShop.Filters.inputs = inputs;
				VegasShop.Filters.setInputs();
				return VegasShop.Filters.submit();
			}
		}

		if (set === 'multiple') {
			if (type === 'range') {
				let $ranges = $($filter).find(".range-slider-filters");

				if ($ranges.length) {
					$ranges.each(function () {
						VegasShop.Filters.range($(this), true);
					});
				}
			}

			$toggle_param.on('click', function () {
				let $filters = $(this).closest(VegasShop.Filters.filters).find(VegasShop.Filters.filter),
					values = [], i = 0;

				$filters.each(function () {
					let param = $(this).find('[data-param]').data('param'),
						type = $(this).data('type'), set = $(this).data('set');

					if (param !== undefined && set === 'multiple') {
						let $values = $(this).find('[data-values]');

						values.push({
							param: param,
							values: []
						});

						if (type === 'checkbox') {
							$values.each(function () {
								if ($(this).hasClass('selected')) {
									values[i].values.push($(this).data('values'));
								}
							});
						} else if (type === 'range') {
							$values.each(function () {
								let val = parseInt($(this).val()) || null,
									min = parseInt($(this).attr('min')) || null,
									max = parseInt($(this).attr('max')) || null;

								if (val !== null) {
									if (min !== null && val < min) val = min;
									if (max !== null && val > max) val = max;
									values[i].values.push(val);
								}
							});

							values[i].values.sort(function(a, b) {
								return a - b;
							});
						}

						if (values[i] && values[i].values.length) {
							inputs[param] = values[i].values;
						} else {
							delete inputs[param];
						}

						i++;
					}
				});

				VegasShop.Filters.inputs = inputs;
				VegasShop.Filters.setInputs();
				return VegasShop.Filters.submit();
			});
		}

		return false;
	},
	range: function ($self, slider = false) {
		if (!slider) {
			let type = $self.data('number'),
				$range = $self.closest(VegasShop.Filters.filters).find('.range-slider-filters'),
				$slider = $range.data("ionRangeSlider"),
				val = parseInt($self.val());

			if (type === 'from') {
				$slider.update({
					from: val
				});
			}

			if (type === 'to') {
				$slider.update({
					to: val
				});
			}
		} else {
			$self.ionRangeSlider({
				skin: "round",
				onChange: function (data) {
					$self.closest(VegasShop.Filters.filter).find('[data-number=from]').val(data.from);
					$self.closest(VegasShop.Filters.filter).find('[data-number=to]').val(data.to);
				}
			});
		}

		return false;
	},
	search: function ($self) {
		let $filter = $self.closest(VegasShop.Filters.filter),
			$val = $filter.find('[data-val]'),
			val = $self.val();

		$val.show();

		if (val.length) {
			val = $.trim(val);
			val = val.toLowerCase();
			val = Transliterate(val, true);

			$filter.find('[data-val]').filter(function () {
				let param = $(this).find('.goods-title').text().toLowerCase();
				return param.indexOf(val) === -1;
			}).hide();
		}

		return false;
	},
	submit: function () {
		$(VegasShop.Filters.form).trigger('submit');
		return false;
	},
	selectedSet: function () {
		let $filters = $(VegasShop.Filters.filters).find(VegasShop.Filters.filter);

		$filters.each(function () {
			let $_self = $(this),
				set = $_self.data('set'),
				type = $_self.data('type');

			if (set === 'sort' ) {
				if (typeof VegasShop.Filters.inputs.sort !== 'undefined') {
					let $values = $_self.find('[data-value'),
						$value = $_self.find('[data-value=' + VegasShop.Filters.inputs.sort +']');

					$values.removeClass('selected');
					$value.addClass('selected');
				}
			}

			if (set === 'multiple') {
				let param = $_self.find('[data-param]').data('param'),
					inputs = VegasShop.Filters.getInputs(param),
					$val = $_self.find('[data-values]'),
					$count_el = $_self.find('.vg-shop-filters__toggle').find('.count-selected-elements');

				if (type === 'checkbox' && $val.length > VegasShop.Filters.search_min_item) {
					$_self.find(VegasShop.Filters.filters + '__item--search').show();
				}

				if (inputs) {
					if ($val.length) {
						inputs = inputs.split(',');

						if (type === 'checkbox') {
							if (inputs.length === 1) {
								let title = $_self.find('[data-values='+ inputs[0] +'] .goods-title').text();
								$count_el.html(': ' + title);
							} else {
								$count_el.html(': ' + inputs.length + ' эл.');
							}

							$.each(inputs, function (key, value) {
								$_self.find('[data-values='+ value +']').addClass('selected');
							});
						} else if (type === 'range') {
							$count_el.html(': ' + inputs.join(' - ') + ' ₽');
						}
					}
				}
			}
		});
	},
	getInputs: function (param = false) {
		VegasShop.Filters.inputs = $(VegasShop.Filters.filters).data('url-json');

		if (VegasShop.Filters.inputs.length === 0) VegasShop.Filters.inputs = {};

		if (param) {
			return VegasShop.Filters.inputs[param];
		}

		return VegasShop.Filters.inputs;
	},
	setInputs: function () {
		let inputs = VegasShop.Filters.inputs,
			$form = $(VegasShop.Filters.form);

		if (!inputs) inputs = {};

		$form.find('input').remove();

		if (Object.keys(inputs).length > 0) {
			function appendInputs(objects) {
				$.each(objects, function (key, value) {
					if (value !== '' && typeof value !== 'object') {
						$form.append('<input type="hidden" name="' + key + '" value="' +  value + '">');
					} else if (typeof value === 'object' && Object.prototype.toString.call(value) !== '[object Array]') {
						appendInputs(value);
					} else if (Object.prototype.toString.call(value) === '[object Array]') {
						let val = value.join(',');
						$form.append('<input type="hidden" name="' + key + '" value="' +  val + '">');
					}
				});
			}

			appendInputs(inputs);
		}

		return true;
	},
	clearFilter: function ($_self) {
		let $filter = $_self.closest(VegasShop.Filters.filters + '__item'),
			set = $filter.data('set');

		if (set === 'single') {
			let param = $filter.find('[data-param]').data('param');

			delete VegasShop.Filters.inputs[param];
			VegasShop.Filters.setInputs();

			return VegasShop.Filters.submit();
		}

		if (set === 'multiple') {
			let param = $filter.find('[data-param]').data('param');

			$filter.find('.selected').removeClass('selected');
			delete VegasShop.Filters.inputs[param];
			VegasShop.Filters.setInputs();

			return VegasShop.Filters.submit();
		}

		return false;
	}
};

$(document).ready(function () {
	if ($(VegasShop.Filters.filters).length) {
		VegasShop.Filters.init();
	}
	
	let $toggleFilter = $('[data-toggle=filter]');
	
	$toggleFilter.each(function () {
		let $self = $(this),
			$filter = $self.closest(VegasShop.Filters.filters + '__item'),
			set = $filter.data('set');
		
		if (set !== 'single') {
			vgDropdown.init($(this));
		}
	});
	
	$toggleFilter.on('click', function () {
		let $self = $(this),
			$filter = $self.closest(VegasShop.Filters.filter),
			set = $filter.data('set');

		if (set !== 'single') {
			vgDropdown.open($self);
		}

		VegasShop.Filters.toggle($filter, $self, set);

		return false;
	});

	$(document).on('click', 'a.param[data-values]', function () {
		$(this).toggleClass('selected');
		return false;
	});

	$('[data-dismiss=filter]').on('click', function () {
		VegasShop.Filters.clearFilter($(this));
		return false;
	});

	$(VegasShop.Filters.filters + ' .search-input').on('keyup change', function () {
		return VegasShop.Filters.search($(this));
	});

	$('[data-range=filter]').on('input keyup', function () {
		VegasShop.Filters.range($(this));
		return false
	});

	$('.selectFilterSort').change(function () {
		let $form = $('#shop-filter-form'),
			$inputs = $form.find('input[name=sort]');

		if ($inputs.length) {
			$inputs.val($(this).val())
		} else {
			$form.append('<input type="hidden" name="sort" value="' +  $(this).val() + '">');
		}

		$form.trigger('submit');
	});
});
